import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './localization/en.json';
import frTranslations from './localization/fr.json';
import arTranslations from './localization/ar.json';

const savedLanguage = localStorage.getItem('userLanguage') || 'fr';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      fr: {
        translation: frTranslations,
      },
      ar: {
        translation: arTranslations,
      },
    },
    lng: savedLanguage,
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;

